var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"default-input",attrs:{"placeholder":_vm.get_placeholder,"required":_vm.required,"type":_vm.type,"name":_vm.name,"title":_vm.get_placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }